
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.83 49.14c-.58 0-1.17-.22-1.62-.66l-14.7-14.22c-.29-.25-.6-.55-.9-.87l-.11-.1c-.09-.09-.17-.18-.23-.27A13.293 13.293 0 019 24.3C9 16.97 14.97 11 22.3 11c2.72 0 5.31.81 7.54 2.35 2.23-1.54 4.82-2.35 7.54-2.35 7.33 0 13.3 5.97 13.3 13.3 0 3.29-1.22 6.44-3.43 8.89-.06.08-.13.16-.21.25l-.1.09c-.17.18-.38.37-.59.57L31.46 48.48c-.46.44-1.04.66-1.63.66z"}})])
          )
        }
      }
    